export const extractFloatFromString = (str: string) => {
  const substrings = str.split(/[^\d.]+/);
  const matchedString = substrings.join('');
  return Number(matchedString);
};
